import { render, staticRenderFns } from "./ResourceHoursConflict.vue?vue&type=template&id=328b475e"
import script from "./ResourceHoursConflict.vue?vue&type=script&lang=js"
export * from "./ResourceHoursConflict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports